import React, { Component } from "react";
import { DropdownButton, MenuItem } from "react-bootstrap";

import EpisodeStats from "../../SmartClinicContainerV2/Component/EpisodeStats/EpisodeStats";

import "./CustomDashboardComponent.css";

function percentage(partialValue, totalValue) {
    return partialValue && totalValue ? (100 * partialValue) / totalValue : 0;
}

const getTotalFromGrowth = growth => {
    let total = 0;
    growth && growth.length && growth.forEach((element, index) => {
        total = total + element.count;
    });

    return total;
};

const getValueFromGrowth = (growth, key) => {
    let value = 0;
    growth && growth.length && growth.forEach((element, index) => {
        element.classification === key ? (value = element.count) : null;
    });

    return value;
};

const GrowthOverview = props => {
    let { growth, total } = props;

    let underweight = getValueFromGrowth(growth, "underweight");
    let normal = getValueFromGrowth(growth, "normal");
    let overweight = getValueFromGrowth(growth, "overweight");
    let obese = getValueFromGrowth(growth, "obese");

    return (
        <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <div className="row table_bmiAnalysis">
                    <div className="col-xs-6 col-sm-3 col__bmi">
                        <div className="col__inner">
                            <img className="bmi_analysis_img" src="img/bmi_under.png" />
                        </div>
                        <span className="bmi__value" title={underweight}>{`${percentage(underweight, total).toFixed(1)} %`}</span>
                        <span className="bmi__status">Underweight</span>
                    </div>
                    <div className="col-xs-6 col-sm-3 col__bmi">
                        <div className="col__inner">
                            <img className="bmi_analysis_img" src="img/bmi_normal.png" />
                        </div>
                        <span className="bmi__value" title={normal}>{`${percentage(normal, total).toFixed(1)} %`}</span>
                        <span className="bmi__status">Normal</span>
                    </div>
                    <div className="col-xs-6 col-sm-3 col__bmi">
                        <div className="col__inner">
                            <img className="bmi_analysis_img" src="img/bmi_over.png" />
                        </div>
                        <span className="bmi__value" title={overweight}>{`${percentage(overweight, total).toFixed(1)} %`}</span>
                        <span className="bmi__status">Overweight</span>
                    </div>
                    <div className="col-xs-6 col-sm-3 col__bmi">
                        <div className="col__inner">
                            <img className="bmi_analysis_img" src="img/bmi_obese.png" />
                        </div>
                        <span className="bmi__value" title={obese}>{`${percentage(obese, total).toFixed(1)} %`}</span>
                        <span className="bmi__status">Obese</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const episodeComplaintMeta = [
    {key: 'today', label: 'Today'},
    {key: 'week', label: 'Current Week'},
    {key: 'month', label: 'Current Month'},
    {key: 'all', label: 'Till Date'},
]

class CustomDashboardComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedClass: null,
            selectedSection: null,
            currentEpisodeComplaintIndex: 0
        };
    }

    componentWillMount() {
        this.props.fetchLatestGrowthOverview(this.props.organizationId);
        this.props.fetchEpisodeStats(this.props.organizationId, episodeComplaintMeta[this.state.currentEpisodeComplaintIndex].key)
        this.props.getSchoolClasses();
    }

    resetClassFilter = () => {
        this.setState({
            selectedClass: null,
            selectedSection: null,
        }, () => this.fetchNewFilteredList(false))
    }

    addNewFilter = (val, field) => {
        const newFilter = {
            [field]: val
        };
        this.setState({ ...newFilter }, () => this.fetchNewFilteredList(true));
    };

    fetchNewFilteredList = (flag) => {
        const { selectedClass, selectedSection } = this.state

        this.props.fetchLatestGrowthOverview(this.props.organizationId, selectedClass, selectedSection);
        this.props.fetchEpisodeStats(this.props.organizationId, episodeComplaintMeta[this.state.currentEpisodeComplaintIndex].key, selectedClass, selectedSection)
    }

    getClasses = (classes, selectedClass, ailment, isSmall) => {
        return (
            <div>
                <button key={"reset"} className="btn hsg-btn-warning right" onClick={() => this.resetClassFilter()}>
                    <span className="glyphicon glyphicon-refresh" aria-hidden="true"></span>
                </button>
                <div className="right temp-dd-class" key={"section"}>
                    <DropdownButton
                        title={this.state.selectedSection || "Section"}
                        id="dropdown-for-section"
                        onSelect={data => this.addNewFilter(data, "selectedSection")}
                    >
                        {!!selectedClass && classes[selectedClass] && classes[selectedClass].length ? (
                            classes[selectedClass].map(section =>
                                this.state.selectedSection === section ? (
                                    <MenuItem key={section} eventKey={section} active>
                                        {section}
                                    </MenuItem>
                                ) : (
                                    <MenuItem key={section} eventKey={section}>
                                        {section}
                                    </MenuItem>
                                )
                            )
                        ) : (
                            <MenuItem>{"Please select a class"}</MenuItem>
                        )}
                    </DropdownButton>
                </div>
                <div className="right" key={"classes"}>
                    <DropdownButton
                        title={this.state.selectedClass || "Class"}
                        id="dropdown-for-class"
                        className="right"
                        onSelect={data => this.addNewFilter(data, "selectedClass")}
                    >
                        {Object.keys(classes).map(eachClass =>
                            this.state.selectedClass === eachClass ? (
                                <MenuItem key={eachClass} eventKey={eachClass} active>
                                    {eachClass}
                                </MenuItem>
                            ) : (
                                <MenuItem key={eachClass} eventKey={eachClass}>
                                    {eachClass}
                                </MenuItem>
                            )
                        )}
                    </DropdownButton>
                </div>
            </div>
        );
    };

    render() {
        let props = this.props;

        let totalGrowth = getTotalFromGrowth(props.growthOverview || [])

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ marginTop: 20 }}>

                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-10">
                    {this.getClasses(this.props.classes, this.state.selectedClass)}
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{}}>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{display: "inline-block"}}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-card-header-v1-label-small">
                            Episode Stats
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <EpisodeStats
                                stats={props.episodeStats}
                                organizationId={props.organizationId}
                                fetchEpisodeStats={(organizationId, StatLimit) =>
                                    props.fetchEpisodeStats(organizationId, StatLimit, this.state.selectedClass, this.state.selectedSection)
                                }
                                noDataAvailable={msg => props.noDataAvailable(msg)}
                            />
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{marginTop: 20}}>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{display: "inline-block"}}>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 hsg-card-header-v1-label-small">
                            {`BMI Analysis (${totalGrowth || 0})`}
                        </div>

                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginTop: 100}}>
                            {
                                totalGrowth ? <GrowthOverview
                                    total={totalGrowth}
                                    growth={props.growthOverview || []}
                                /> :  props.noDataAvailable('No data available.')
                            }
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default CustomDashboardComponent;



// WEBPACK FOOTER //
// ./src/Containers/DashboardContainer/Component/CustomDashboardComponent.js